import axios from "axios";

export const getOneExpociencias22 = async (props) => {
    
    const url = process.env.REACT_APP_BASE_URL + `/api/expociencias22/${props}`;
    
    var result = [];

    await axios.get(url)
    .then((response) => {
        const data = response.data;
        result = { ...data };
        if (data.exito === 1) {
            console.log("registro recuperado...");
        }
    });

    return result;
};
